import React from 'react';

const BS_Wells = () => {
    return (
        <div>
            <h1>BS_Wells Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Wells;
